import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertController, IonInput, IonSlides, IonTextarea, LoadingController, ModalController, Platform, PopoverController} from '@ionic/angular';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import * as apiVeranstaltungen from './../../../clients/veranstaltungen';
import {AufgabeAdmin, VeranstaltungenBenutzerZugriff, Checkliste, Dokument, Funktionsbereich, FunktionsbereichBerechtigung, FunktionsbereichRollen,
    KopfdatenElement,
    Rolle, RolleBenutzer, Veranstaltung,
    VeranstaltungStatus} from '../../../clients/veranstaltungen';
import * as apiVorlagen from './../../../clients/vorlagen';
import {DokumentBerechtigung} from '../../../clients/vorlagen';
import * as fromVeranstaltungenPage from './veranstaltungen.reducer';
import {FormControl, FormGroup} from '@angular/forms';
import {Settings} from '@orga-app/settings/settings.model';
import {select, Store} from '@ngrx/store';
import * as fromMandantModule from '@orga-app/mandant/reducer';
import {getIstAufgabenBerechtigungenLizenzAktiv, getIstPandemieLizenzAktiv, getPandemieMandantOptions} from '@orga-app/mandant/reducer';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {ImageService} from '@orga-app/providers/image.service';
import {DocumentService} from '@orga-app/providers/document.service';
import {UploadResponse, UploadService} from '../../../clients/api';
import {WindowRefService} from '@orga-app/providers/window.service';
import {UuidService} from '@orga-app/providers/uuid.service';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {
    GetChecklisteAbarbeiterRollenAdminAction,
    GetChecklisteAufgabenAdminAction,
    GetChecklisteFreigabeRollenAdminAction,
    GetChecklisteLeseRollenAdminAction,
    GetFunktionsbereichChecklistenAdminAction,
    GetRolleBenutzerAdminAction, GetVeranstaltungBerechtigungenAdminAction,
    GetVeranstaltungDetailAdminAction,
    GetVeranstaltungDokumentBerechtigungAction,
    GetVeranstaltungDokumenteAdminAction,
    GetVeranstaltungenAngelegteAdminAction,
    GetVeranstaltungenBeendeteAdminAction,
    GetVeranstaltungenVeroeffentlichteAdminAction,
    GetVeranstaltungFunktionsbereicheAdminAction,
    GetVeranstaltungFunktionsbereicheChecklistenAdminAction,
    GetVeranstaltungFunktionsbereicheRollenAdminAction,
    GetVeranstaltungFunktionsbereicheRollenAdminAlleAction,
    GetVeranstaltungStatusAction,
    PostAufgabeAktivierenAction,
    PostAufgabeAktualisierenAction,
    PostAufgabeDeaktivierenAction,
    PostBenutzerVomDienstBefreienAction,
    PostBenutzerZumDienstEinteilenMultiAction,
    PostChecklisteEntfernenAction,
    PostChecklisteHinzufuegenMultiAction,
    PostDokumentAktualisierenAction,
    PostDokumentBearbeitenBerechtigungHinzufuegenMultiAction,
    PostDokumentBerechtigungHinzufuegenMultiAction,
    PostDokumentEntfernenAction,
    PostDokumentHinzufuegenAction,
    PostDokumentUploadAktualisierenAction,
    PostFunktionsbereichEntfernenAction,
    PostFunktionsbereichHinzufuegenMultiAction,
    PostVeranstaltungAnlegenAction,
    PostVeranstaltungBeendenAction,
    PostVeranstaltungFreigebenAction,
    PostVeranstaltungKopfdatenAktualisierenAction,
    PostVeranstaltungKopierenAction,
    PostVeranstaltungLoeschenAction,
    PostVeranstaltungLogoAktualisierenAction,
    PostVeranstaltungNichtVeroeffentlichenAction,
    PostVeranstaltungPhaseBeendenAction,
    PostVeranstaltungReaktivierenAction,
    PostVeranstaltungVeroeffentlichenAction
} from '../../../client-ngrx/veranstaltungen';
import {
    AktuellesDokumentAendernAction,
    AufgabeSetzenAction, BenutzerberechtigungenEntfernenAction, BenutzerberechtigungenHinzufuegenAction,
    DokumentBearbeitenBerechtigungenEntfernenAction,
    DokumentBearbeitenBerechtigungenSelectedSetzenAction,
    DokumentIdSetzenAction,
    DokumentLeseBerechtigungenEntfernenAction,
    DokumentLeseBerechtigungenSelectedSetzenAction,
    DokumentSelectedSetzenAction,
    DokumentUploadSetzenAction,
    FunktionsbereichChecklisteSetzenAction, FunktionsbereichSetzenAction,
    NeueVeranstaltungAbbrechenAction,
    NeueVeranstaltungAction,
    NeueVeranstaltungDetailSetzenAction,
    PageStateResetAction,
    PandemieLevelAbfrageAction,
    PandemieLevelEinstellenAction,
    RollenBenutzerSetzenAction,
    RolleSetzenAction, SetSelectedAufgabenAction,
    SetzePandemieLevelUiAction,
    SetzeVeranstaltungBeginnAction,
    SetzeVeranstaltungEinlassAction,
    SetzeVeranstaltungFeldAction,
    SetzeVeranstaltungSaisonAction,
    SetzeVeranstaltungStichtagPandemieLevelAction,
    SetzeVeranstaltungTitelAction,
    SetzeVeranstaltungVeranstaltungsbeobachterAction,
    SetzeVeranstaltungVeranstaltungsleiterAction,
    VeranstaltungDetailResetAction
} from './veranstaltungen.actions.ui';
import {filter, takeUntil, takeWhile} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {FunktionsbereichsauswahlPage} from '../funktionsbereichsauswahl/funktionsbereichsauswahl.page';
import {FunktionsbereichEntfernenPage} from '../funktionsbereich-entfernen/funktionsbereich-entfernen.page';
import {ChecklisteEntfernenPage} from '../checkliste-entfernen/checkliste-entfernen.page';
import {ChecklistenauswahlPage} from '../checklistenauswahl/checklistenauswahl.page';
import {Md2DateChange} from 'angular-md2/lib/datepicker/datepicker';
import {VeranstaltungLoeschenPage} from '../veranstaltung-loeschen/veranstaltung-loeschen.page';
import {getZugriffVeranstaltungen} from '../../navi/navi.reducer';
import {VeranstaltungKopierenPage} from '../veranstaltung-kopieren/veranstaltung-kopieren.page';
import {NotificationService} from '@orga-app/providers/notification.service';
import {expandCollapsiblePanelAnimation} from '../../../sopi/animations';
import {AufgabePage} from '../aufgabe/aufgabe.page';
import {HinweisMeldungPage} from '../../shared/hinweis-meldung/hinweis-meldung.page';
import {getTheme} from '@orga-app/settings/reducer';
import {Datenquelle} from '../rollenselektion/rollenselektion.model';
import {RollenselektionPage} from '../rollenselektion/rollenselektion.page';
import {PandemieLevel, PandemieMandantOptions, VeranstaltungPandemieCheck, VeranstaltungPandemieInfo} from '../../../clients/pandemie';
import {GetVeranstaltungPandemieInfoAction} from '../../../client-ngrx/pandemie';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {DatenquelleVeranstaltungsTypen} from '../../modale/veranstaltungstyp-auswahl/veranstaltungstyp-auswahl.model';
import {VeranstaltungstypAuswahlPage} from '../../modale/veranstaltungstyp-auswahl/veranstaltungstyp-auswahl.page';
import {GetVeranstaltungsTypRolleBenutzerAction} from '../../../client-ngrx/veranstaltungstypen';
import {
    getUiZeigeDetailbereich,
    getUiZeigeVeranstaltungenDetailLadeanimation,
    getUiZeigeFunktionsbereicheLadeanimation,
    getUiZeigeChecklistenLadeanimation,
    getUiZeigeAufgabenLadeanimation,
    getUiZeigeAufgabenFehler,
    getUiZeigeBenutzerverwaltungRolleBenutzer,
    getUiZeigeVeranstaltungLoeschen,
    getUiZeigeNeueVeranstaltung,
    getUiZeigeFunktionsbereicheChecklistenLaden,
    getUiZeigeFunktionsbereicheChecklistenFehler,
    getUiSelektiertFunktionsbereicheCheckliste,
    getUiFunktionsbereicheRollen,
    getUiRollenBenutzerSelektiert,
    getFunktionsbereicheListe,
    getFunktionsbereicheChecklistenListe,
    getChecklistenListe,
    getAufgabenListe,
    getSelectedAufgabe,
    getFreigabeRollenListe,
    getLeseRollenListe,
    getAbarbeiterRollenListe,
    getFunktionsbereicheRollenAlleListe,
    getFunktionsbereicheRollenListeLaden,
    getVeranstaltungRollenListe,
    getRolleBenutzerListe,
    getDokumenteListe,
    getAllgemeineDokumenteListe,
    getVeroeffentlichteVeranstaltungenListe,
    getBeendeteVeranstaltungenListe,
    getAngelegteVeranstaltungenListe,
    getVeranstaltungenDetail,
    getUiBenutzerverwaltungRolleBenutzerListe,
    getAktiveVeranstaltungen,
    getArchivierteVeranstaltungen, getAnzahlSpieltagDokumente, getAnzahlAllgemeineDokumente, getVeranstaltungStatus,
    getDokumentSelected, getDokumenteLadeanimation, getDokumentBerechtigung, getDokumentBerechtigungLaden,
    getDokumentBerechtigungFehler, getLeseBerechtigungRollen, getBearbeitenBerechtigungRollen, getDokumentLeseBerechtigungenSelected,
    getDokumentBearbeitenBerechtigungenSelected,
    getPandemieCheck, getPandemieLevelStichtag, getSelectedPandemieLevelId, getUiAngelegteVeranstaltungenListeLadeanimation,
    getUiBeendeteVeranstaltungenListeLadeanimation, getUiVeroeffentlichteVeranstaltungenListeLadeanimation,
    getVeranstaltungPandemieInfo, getVeranstaltungPandemieInfoFehler,
    getVeranstaltungPandemieInfoLaden, getFunktionsbereicheLaden, getFunktionsbereicheFehler, getFunktionsbereiche, getSelectedFunktionsbereichId, getChecklistenAufgaben, getChecklistenAufgabenLaden, getChecklistenAufgabenFehler, getSelectedAufgaben, getVeranstaltungBerechtigungen
} from './veranstaltungen.selectors';
import {AufgabenBerechtigungenModalPage} from '../aufgaben-berechtigungen/aufgaben-berechtigungen-modal/aufgaben-berechtigungen-modal.page';
import {PopoverComponentPage} from '../aufgaben-berechtigungen/popover-component/popover-component.page';
import {Benutzer} from '../../../clients/veranstaltungen';
import {FunktionsbereichRolle, VeranstaltungBerechtigung} from '../../../clients/veranstaltungen';

@Component({
    selector: 'app-veranstaltungen',
    templateUrl: './veranstaltungen.page.html',
    styleUrls: ['./veranstaltungen.page.scss'],
    animations: [
        expandCollapsiblePanelAnimation
    ]
})
export class Veranstaltungen2Page implements OnInit, OnDestroy {
    @ViewChild(IonSlides, {static: false}) slides: IonSlides;
    @ViewChild('logoFileInput', {static: false, read: ElementRef}) logoFileInput: ElementRef;
    @ViewChild('dokumentFileInput', {static: false, read: ElementRef}) dokumentFileInput: ElementRef;
    @ViewChild('dokumentImagePlaceholder', {static: false}) dokumentImagePlaceholder: ElementRef;
    @ViewChild('infoKategorieTitelInput', {static: false}) infoKategorieTitelInput: IonInput;
    @ViewChild('dokumentTitelInput', {static: false}) dokumentTitelInput: IonInput;
    @ViewChild('aktionTitelInput', {static: false}) aktionTitelInput: IonInput;
    @ViewChild('inputVeranstaltungTitelNeu', {static: false}) inputVeranstaltungTitelNeu: IonInput;
    @ViewChild('inputVeranstaltungTitel', {static: false}) inputVeranstaltungTitel: IonInput;
    @ViewChild('mitteilungstextInput', {static: false}) mitteilungstextInput: IonTextarea;
    collapsiblePanelOpen = 'open';
    settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    windowLocal: Window;
    aiName = 'VeranstaltungenPage';
    alive = true;
    public istPandemieLizenzAktiv$: Observable<boolean>;

    pandemieMandantOptions$: Observable<PandemieMandantOptions>;

    // Neu Umbau MKB
    aktuelleVeranstaltung$: Observable<apiVeranstaltungen.Veranstaltung>;
    veranstaltungBerechtigungen$: Observable<VeranstaltungBerechtigung>;

    // QUERIES, COMMANDS AND UPDATES
    funktionsbereich$: Observable<Array<Funktionsbereich>>;
    funktionsbereicheChecklisten$: Observable<Array<ListInputItem>>;
    checkliste$: Observable<Array<Checkliste>>;
    aufgabe$: Observable<Array<ListInputItem>>;
    selectedAufgabe$: Observable<AufgabeAdmin>;
    funktionsbereicheRollenAlle$: Observable<Array<FunktionsbereichRollen>>;
    funktionsbereicheRollenLaden$: Observable<boolean>;
    veranstaltungRollen$: Observable<Array<Rolle>>;
    rolleBenutzer$: Observable<Array<RolleBenutzer>>;
    // TODO V3 - war vorher ohne Liste
    uiBenutzerverwaltungRolleBenutzerListe$: Observable<Array<ListInputItem>>;
    freigabeRollen$: Observable<Array<FunktionsbereichRolle>>;
    leseRollen$: Observable<Array<FunktionsbereichRolle>>;
    abarbeiterRollen$: Observable<Array<FunktionsbereichRolle>>;
    // TODO V3 - irgendwie ist das doppelt
    veroeffentlichteVeranstaltungen$: Observable<Array<Veranstaltung>>;
    beendeteVeranstaltungen$: Observable<Array<Veranstaltung>>;
    angelegteVeranstaltungen$: Observable<Array<Veranstaltung>>;
    angelegteVeranstaltungenDetail$: Observable<apiVeranstaltungen.VeranstaltungDetail>;
    uiSelektiertFunktionsbereicheCheckliste$: Observable<apiVeranstaltungen.Checkliste>;
    angelegteVeranstaltungenDetail: apiVeranstaltungen.VeranstaltungDetail;
    // Mitteilungen
    aktiveVeranstaltungen$: Observable<Array<ListInputItem>>;
    archivierteVeranstaltungen$: Observable<Array<ListInputItem>>;
    veranstaltungStatus$: Observable<apiVeranstaltungen.VeranstaltungStatus>;
    aktuelleVeranstaltungId: string;
    uiFunktionsbereicheRollen$: Observable<Array<ListInputItem>>;
    // UI
    aktuellerTab = 'Kopfdaten';
    aktuellerTabVeranstaltungen = 'Aktive';
    aktuellerDokumentenartTab = 'Veranstaltung';
    aktuellerBerechtigungsTab = 'Lesen';
    aktuellerClBerechtigungsTab = 'Freigeben';
    aktuellerClUndAufgabenTab = 'Aufgaben';
    aktuellerFunktionsbereich: apiVeranstaltungen.Funktionsbereich;
    aktuellerBeteiligterFunktionsbereich: apiVeranstaltungen.Funktionsbereich;
    aktuelleAktion: apiVeranstaltungen.Aktion;
    aktuelleChecklisten: Array<apiVeranstaltungen.Checkliste>;
    rollenBenutzerAktuellerFunktionsbereich: apiVeranstaltungen.Funktionsbereich;
    rollenBenutzerAktuelleFBBerechtigungen: apiVeranstaltungen.FunktionsbereichBerechtigung;
    rollenBenutzerAktuelleRolle: apiVeranstaltungen.Rolle;
    uiAngelegteVeranstaltungenListeLadeanimation$: Observable<boolean>;
    uiVeroeffentlichteVeranstaltungenListeLadeanimation$: Observable<boolean>;
    uiBeendeteVeranstaltungenListeLadeanimation$: Observable<boolean>;
    uiZeigeDetailbereich$: Observable<boolean>;
    uiZeigeVeranstaltungenDetailLadeanimation$: Observable<boolean>;
    uiZeigeFunktionsbereicheLadeanimation$: Observable<boolean>;
    uiZeigeChecklistenLadeanimation$: Observable<boolean>;
    uiZeigeAufgabenLadeanimation$: Observable<boolean>;
    uiZeigeAufgabenFehler$: Observable<boolean>;
    uiZeigeBenutzerverwaltungRolleBenutzerLadeanimation$: Observable<boolean>;
    uiZeigeVeranstaltungLoeschen$: Observable<boolean>;
    uiZeigeNeueVeranstaltung$: Observable<boolean>;
    uiZeigeFunktionsbereicheChecklistenLaden$: Observable<boolean>;
    uiZeigeFunktionsbereicheChecklistenFehler$: Observable<boolean>;
    uiRollenBenutzerSelektiert$: Observable<Array<string>>;
    initalSlide: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    currentSlideIndex$: Observable<number>;
    veranstaltungTitelOriginal: string;
    leseBerechtigungRollen$: Observable<Array<ListInputItem>>;
    bearbeitenBerechtigungRollen$: Observable<Array<ListInputItem>>;
    leseBerechtigungenSelected$: Observable<Array<string>>;
    bearbeitenBerechtigungenSelected$: Observable<Array<string>>;

    // Dokument-Reiter
    dokument$: Observable<Array<ListInputItem>>;
    dokumentAllgemein$: Observable<Array<ListInputItem>>;

    dokumentSelected$: Observable<Dokument>;
    dokumentLadeanimation$: Observable<boolean>;

    dokumentBerechtigung$: Observable<DokumentBerechtigung>;
    dokumentBerechtigungLaden$: Observable<boolean>;
    dokumentBerechtigungFehler$: Observable<boolean>;

    image: any;
    veranstaltungsId: string;
    logoBlobId: string;
    zugriff$: Observable<VeranstaltungenBenutzerZugriff>;
    anzahlSpieltagDokumente$: Observable<number>;
    anzahlAllgemeineDokumente$: Observable<number>;
    aufgabeFunktionsbereich: apiVeranstaltungen.Funktionsbereich;
    de: any;
    veranstaltungForm: FormGroup;
    setFocus = false;
    public sectionAktionPreviewIstOffen = true;

    pandemieCheck$: Observable<VeranstaltungPandemieCheck>;
    selectedPandemieLevelId$: Observable<number>;
    pandemieLevelStichtag$: Observable<Date>;

    veranstaltungPandemieInfo$: Observable<VeranstaltungPandemieInfo>;
    veranstaltungPandemieInfoLaden$: Observable<boolean>;
    veranstaltungPandemieInfoFehler$: Observable<boolean>;


    // AufgabenBerechtigungen
    public istAufgabenBenutzerBerechtigungenLizenzAktiv$: Observable<boolean>;
    public funktionsbereiche$: Observable<Array<ListInputItem>>;
    public funktionsbereicheLaden$: Observable<boolean>;
    public funktionsbereicheFehler$: Observable<boolean>;

    public selectedFunktionsbereichId$: Observable<string>;

    public checklistenAufgaben$: Observable<Array<ListInputItem>>;
    public checklistenAufgabenLaden$: Observable<boolean>;
    public checklistenAufgabenFehler$: Observable<boolean>;

    public selectedAufgabenIds$: Observable<Array<string>>;
    private unsubscribe$ = new Subject();

    constructor(
        public modalCtrl: ModalController,
        private imageService: ImageService,
        private documentService: DocumentService,
        private uploadCommandService: UploadService,
        public loadingCtrl: LoadingController,
        private windowRefService: WindowRefService,
        private uuid: UuidService,
        private sanitizer: DomSanitizer,
        public alertCtrl: AlertController,
        public element: ElementRef,
        private store: Store<fromVeranstaltungenPage.PageState>,
        private storeMandant: Store<fromMandantModule.MandantState>,
        public settingsProvider: SettingsProvider,
        public platform: Platform,
        public route: ActivatedRoute,
        private notificationService: NotificationService,
        public router: Router,
        private popoverController: PopoverController) {

        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));

        this.currentSlideIndex$ = this.initalSlide.asObservable();

        this.veranstaltungForm = new FormGroup({
            datumEinlass: new FormControl(''),
            datumBeginn: new FormControl('')
        });
    }

    async tabChanged($event: CustomEvent) {
        if ($event.detail.value === 'Kopfdaten') {
            setTimeout(() => {
                if (this.inputVeranstaltungTitel) {
                    this.inputVeranstaltungTitel.setFocus();
                }
            }, 500);
        }

        if ($event.detail.value === 'Mitteilungen') {
            setTimeout(() => {
                if (this.mitteilungstextInput) {
                    this.mitteilungstextInput.setFocus();
                }
            }, 500);
        }
    }

    async changeBeginn($event: Md2DateChange) {
        this.store.dispatch(new SetzeVeranstaltungBeginnAction($event.value));
    }

    async changeEinlass($event: Md2DateChange) {
        this.store.dispatch(new SetzeVeranstaltungEinlassAction($event.value));
    }

    async toggleCollapsiblePanel() {
        this.collapsiblePanelOpen = (this.collapsiblePanelOpen === 'open') ? 'closed' : 'open';
    }

    ngOnInit() {
        this.windowLocal = this.windowRefService.nativeWindow;

        // Neu Umbau MKB
        this.veranstaltungBerechtigungen$ = this.store.pipe(select(getVeranstaltungBerechtigungen));

        this.istPandemieLizenzAktiv$ = this.storeMandant.pipe(select(getIstPandemieLizenzAktiv));
        this.pandemieCheck$ = this.store.pipe(select(getPandemieCheck));
        this.pandemieMandantOptions$ = this.storeMandant.pipe(select(getPandemieMandantOptions));
        this.selectedPandemieLevelId$ = this.store.pipe(select(getSelectedPandemieLevelId));
        this.pandemieLevelStichtag$ = this.store.pipe(select(getPandemieLevelStichtag));

        this.veranstaltungPandemieInfo$ = this.store.pipe(select(getVeranstaltungPandemieInfo));
        this.veranstaltungPandemieInfoLaden$ = this.store.pipe(select(getVeranstaltungPandemieInfoLaden));
        this.veranstaltungPandemieInfoFehler$ = this.store.pipe(select(getVeranstaltungPandemieInfoFehler));

        // UI
        this.uiAngelegteVeranstaltungenListeLadeanimation$ = this.store.pipe(select(getUiAngelegteVeranstaltungenListeLadeanimation));
        this.uiVeroeffentlichteVeranstaltungenListeLadeanimation$ = this.store.pipe(select(getUiVeroeffentlichteVeranstaltungenListeLadeanimation));
        this.uiBeendeteVeranstaltungenListeLadeanimation$ = this.store.pipe(select(getUiBeendeteVeranstaltungenListeLadeanimation));
        this.zugriff$ = this.store.pipe(select(getZugriffVeranstaltungen));
        this.uiZeigeDetailbereich$ = this.store.pipe(select(getUiZeigeDetailbereich));
        this.uiZeigeVeranstaltungenDetailLadeanimation$ = this.store.pipe(select(getUiZeigeVeranstaltungenDetailLadeanimation));
        this.uiZeigeFunktionsbereicheLadeanimation$ = this.store.pipe(select(getUiZeigeFunktionsbereicheLadeanimation));
        this.uiZeigeChecklistenLadeanimation$ = this.store.pipe(select(getUiZeigeChecklistenLadeanimation));
        this.uiZeigeAufgabenLadeanimation$ = this.store.pipe(select(getUiZeigeAufgabenLadeanimation));
        this.uiZeigeAufgabenFehler$ = this.store.pipe(select(getUiZeigeAufgabenFehler));
        this.uiZeigeBenutzerverwaltungRolleBenutzerLadeanimation$ = this.store.pipe(select(getUiZeigeBenutzerverwaltungRolleBenutzer));
        this.uiZeigeVeranstaltungLoeschen$ = this.store.pipe(select(getUiZeigeVeranstaltungLoeschen));
        this.uiZeigeNeueVeranstaltung$ = this.store.pipe(select(getUiZeigeNeueVeranstaltung));
        this.uiZeigeFunktionsbereicheChecklistenLaden$ = this.store.pipe(select(getUiZeigeFunktionsbereicheChecklistenLaden));
        this.uiZeigeFunktionsbereicheChecklistenFehler$ = this.store.pipe(select(getUiZeigeFunktionsbereicheChecklistenFehler));
        this.uiSelektiertFunktionsbereicheCheckliste$ = this.store.pipe(select(getUiSelektiertFunktionsbereicheCheckliste));
        this.uiFunktionsbereicheRollen$ = this.store.pipe(select(getUiFunktionsbereicheRollen));
        this.uiRollenBenutzerSelektiert$ = this.store.pipe(select(getUiRollenBenutzerSelektiert));
        // DATA
        this.funktionsbereich$ = this.store.pipe(select(getFunktionsbereicheListe));
        this.funktionsbereicheChecklisten$ = this.store.pipe(select(getFunktionsbereicheChecklistenListe));
        this.checkliste$ = this.store.pipe(select(getChecklistenListe));
        this.aufgabe$ = this.store.pipe(select(getAufgabenListe));
        this.selectedAufgabe$ = this.store.pipe(select(getSelectedAufgabe));
        this.freigabeRollen$ = this.store.pipe(select(getFreigabeRollenListe));
        this.leseRollen$ = this.store.pipe(select(getLeseRollenListe));
        this.abarbeiterRollen$ = this.store.pipe(select(getAbarbeiterRollenListe));
        this.funktionsbereicheRollenAlle$ = this.store.pipe(select(getFunktionsbereicheRollenAlleListe));
        this.funktionsbereicheRollenLaden$ = this.store.pipe(select(getFunktionsbereicheRollenListeLaden));
        this.veranstaltungRollen$ = this.store.pipe(select(getVeranstaltungRollenListe));
        this.rolleBenutzer$ = this.store.pipe(select(getRolleBenutzerListe));
        this.dokument$ = this.store.pipe(select(getDokumenteListe));
        this.dokumentAllgemein$ = this.store.pipe(select(getAllgemeineDokumenteListe));
        this.veroeffentlichteVeranstaltungen$ = this.store.pipe(select(getVeroeffentlichteVeranstaltungenListe));
        this.beendeteVeranstaltungen$ = this.store.pipe(select(getBeendeteVeranstaltungenListe));
        this.angelegteVeranstaltungen$ = this.store.pipe(select(getAngelegteVeranstaltungenListe));
        this.angelegteVeranstaltungenDetail$ = this.store.pipe(select(getVeranstaltungenDetail));
        this.uiBenutzerverwaltungRolleBenutzerListe$ = this.store.pipe(select(getUiBenutzerverwaltungRolleBenutzerListe));

        this.aktiveVeranstaltungen$ = this.store.pipe(select(getAktiveVeranstaltungen));
        this.archivierteVeranstaltungen$ = this.store.pipe(select(getArchivierteVeranstaltungen));

        this.anzahlSpieltagDokumente$ = this.store.pipe(select(getAnzahlSpieltagDokumente));
        this.anzahlAllgemeineDokumente$ = this.store.pipe(select(getAnzahlAllgemeineDokumente));
        this.veranstaltungStatus$ = this.store.pipe(select(getVeranstaltungStatus));

        this.dokumentSelected$ = this.store.pipe(select(getDokumentSelected));
        this.dokumentLadeanimation$ = this.store.pipe(select(getDokumenteLadeanimation));

        this.dokumentBerechtigung$ = this.store.pipe(select(getDokumentBerechtigung));
        this.dokumentBerechtigungLaden$ = this.store.pipe(select(getDokumentBerechtigungLaden));
        this.dokumentBerechtigungFehler$ = this.store.pipe(select(getDokumentBerechtigungFehler));

        this.leseBerechtigungRollen$ = this.store.pipe(select(getLeseBerechtigungRollen));
        this.bearbeitenBerechtigungRollen$ = this.store.pipe(select(getBearbeitenBerechtigungRollen));
        this.leseBerechtigungenSelected$ = this.store.pipe(select(getDokumentLeseBerechtigungenSelected));
        this.bearbeitenBerechtigungenSelected$ = this.store.pipe(select(getDokumentBearbeitenBerechtigungenSelected));

        this.angelegteVeranstaltungenDetail$.subscribe((x: apiVeranstaltungen.VeranstaltungDetail) => {

            if (x !== null) {
                this.aktuelleVeranstaltungId = x.veranstaltung_id;
                this.angelegteVeranstaltungenDetail = Object.assign({}, x);
                this.veranstaltungTitelOriginal = x.titel;

                // Aktuell selektierte aktion gegen neue ersetzen, da sich die Reihenfolge geändert haben könnte
                if (this.aktuelleAktion !== undefined && this.aktuelleAktion !== null) {
                    const resAktionen = x.aktionen.find((y: apiVeranstaltungen.Aktion) => {
                        return y.aktion_id === this.aktuelleAktion.aktion_id;
                    });
                    if (resAktionen) {
                        this.aktuelleAktion = Object.assign({}, resAktionen);
                    }
                }

                // Falls das Datum  noch nicht gesetzt ist, wird es gegen das aktuelle getauscht
                if (x.beginn_utc === undefined || x.beginn_utc === null || x.beginn_utc.toString() === '0001-01-01T00:00:00Z' || x.beginn_utc.toString() === '0001-01-01T00:00:00') {
                    const beginn = new Date();
                    this.veranstaltungForm.get('datumBeginn').setValue(beginn);
                } else {
                    // SET FORM VALUE
                    this.veranstaltungForm.get('datumBeginn').setValue(x.beginn_utc);
                }

                if (x.einlass_utc === undefined || x.einlass_utc === null || x.einlass_utc.toString() === '0001-01-01T00:00:00Z' || x.einlass_utc.toString() === '0001-01-01T00:00:00') {
                    const einlass = new Date();
                    this.veranstaltungForm.get('datumEinlass').setValue(einlass);
                } else {
                    // SET FORM VALUE
                    this.veranstaltungForm.get('datumEinlass').setValue(x.einlass_utc);
                }

                if (x.logo_blob_id !== undefined && x.logo_blob_id !== null && x.logo_blob_id !== '') {
                    if (this.veranstaltungsId !== x.veranstaltung_id || this.logoBlobId !== x.logo_blob_id) {
                        this.imageService.getImage('/api/query/veranstaltungen/' + x.veranstaltung_id + '/logo/scale/200/200')
                            .pipe(
                                takeWhile(() => this.alive)
                                , filter(image => !!image)
                            )
                            .subscribe(image => {
                                    // this.logoImagePlaceholder.nativeElement.src = this.windowLocal.URL.createObjectURL(image);
                                    this.veranstaltungsId = x.veranstaltung_id;
                                    this.logoBlobId = x.logo_blob_id;

                                    const blob = new Blob([image]);

                                    const urlCreator = window.URL;
                                    this.image = this.sanitizer.bypassSecurityTrustUrl(
                                        urlCreator.createObjectURL(blob));
                                },
                                error => {
                                    this.image = null;
                                    // this.logoImagePlaceholder.nativeElement.src = "";
                                });
                    }
                } else {
                    this.image = null;
                }
                setTimeout(() => {
                    if (this.setFocus && this.inputVeranstaltungTitel) {
                        this.setFocus = false;
                        this.inputVeranstaltungTitel.setFocus();
                    }
                }, 1000);
            }
        });

        this.uiSelektiertFunktionsbereicheCheckliste$.subscribe(checkliste => {
            if (checkliste !== null) {
                this.store.dispatch(new GetChecklisteAufgabenAdminAction(checkliste.checkliste_id));
                this.store.dispatch(new GetChecklisteFreigabeRollenAdminAction(checkliste.checkliste_id));
                this.store.dispatch(new GetChecklisteLeseRollenAdminAction(checkliste.checkliste_id));
                this.store.dispatch(new GetChecklisteAbarbeiterRollenAdminAction(checkliste.checkliste_id));
            }
        });

        // Aufgaben Berechtigungen
        this.istAufgabenBenutzerBerechtigungenLizenzAktiv$ = this.store.pipe(select(getIstAufgabenBerechtigungenLizenzAktiv));

        this.funktionsbereiche$ = this.store.pipe(select(getFunktionsbereiche));
        this.funktionsbereicheLaden$ = this.store.pipe(select(getFunktionsbereicheLaden));
        this.funktionsbereicheFehler$ = this.store.pipe(select(getFunktionsbereicheFehler));

        this.selectedFunktionsbereichId$ = this.store.pipe(select(getSelectedFunktionsbereichId));
        this.checklistenAufgaben$ = this.store.pipe(select(getChecklistenAufgaben));
        this.checklistenAufgabenLaden$ = this.store.pipe(select(getChecklistenAufgabenLaden));
        this.checklistenAufgabenFehler$ = this.store.pipe(select(getChecklistenAufgabenFehler));

        this.selectedAufgabenIds$ = this.store.pipe(select(getSelectedAufgaben));

    }


    ngOnDestroy(): void {
      this.unsubscribe$.complete();
  }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        this.store.dispatch(new PageStateResetAction());
        await this.veranstaltungenLaden();
    }

    async veranstaltungenLaden() {
        this.store.dispatch(new GetVeranstaltungenAngelegteAdminAction());
        this.store.dispatch(new GetVeranstaltungenVeroeffentlichteAdminAction());
        this.store.dispatch(new GetVeranstaltungenBeendeteAdminAction());
    }


// VERANSTALTUNG ANLEGEN
    async neueVeranstaltung() {
        this.setFocus = true;
        this.aktuellerFunktionsbereich = null;
        this.store.dispatch(new NeueVeranstaltungAction());
        setTimeout(() => {
            if (this.inputVeranstaltungTitelNeu) {
                this.inputVeranstaltungTitelNeu.setFocus();
            }
        }, 500);
    }

    async neueVeranstaltungAbbrechen() {
        this.aktuellerFunktionsbereich = null;
        this.store.dispatch(new NeueVeranstaltungAbbrechenAction());
    }

    async veranstaltungAnlegen() {
        if (this.angelegteVeranstaltungenDetail.titel !== '' && this.angelegteVeranstaltungenDetail.typ_id !== undefined && this.angelegteVeranstaltungenDetail.typ_id !== null) {
            this.angelegteVeranstaltungenDetail.veranstaltung_id = this.uuid.generateUUID();
            const request = <apiVeranstaltungen.VeranstaltungAnlegenRequest>{
                veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                titel: this.angelegteVeranstaltungenDetail.titel,
                typ_id: this.angelegteVeranstaltungenDetail.typ_id,
                zeitpunkt_utc: new Date()
            };

            this.store.dispatch(new NeueVeranstaltungDetailSetzenAction(this.angelegteVeranstaltungenDetail));
            this.store.dispatch(new PostVeranstaltungAnlegenAction(request));
        } else {
            await this.notificationService.showAlertWarnung('Speichern nicht möglich', '', 'Bitte zuerst alle Pflichtfelder füllen.');
        }
    }

    async veranstaltungLaden(item: apiVeranstaltungen.Veranstaltung) {
        if (item !== null && item.veranstaltung_id !== undefined && item.veranstaltung_id !== null) {
            this.aktuelleVeranstaltung$ = of(item);
            this.setFocus = true;
            this.angelegteVeranstaltungenDetail = null;
            this.aktuelleAktion = null;
            this.aktuelleChecklisten = null;
            this.rollenBenutzerAktuelleRolle = null;
            this.rollenBenutzerAktuellerFunktionsbereich = null;
            this.rollenBenutzerAktuelleFBBerechtigungen = null;
            this.store.dispatch(new VeranstaltungDetailResetAction());
            this.store.dispatch(new GetVeranstaltungDetailAdminAction(item.veranstaltung_id));
            this.store.dispatch(new GetVeranstaltungFunktionsbereicheAdminAction(item.veranstaltung_id));
            this.store.dispatch(new GetVeranstaltungFunktionsbereicheChecklistenAdminAction(item.veranstaltung_id));
            this.store.dispatch(new GetVeranstaltungFunktionsbereicheRollenAdminAction(item.veranstaltung_id));
            this.store.dispatch(new GetVeranstaltungFunktionsbereicheRollenAdminAlleAction(item.veranstaltung_id));
            this.store.dispatch(new GetVeranstaltungDokumenteAdminAction(item.veranstaltung_id));

            this.store.dispatch(new GetVeranstaltungStatusAction(item.veranstaltung_id));

            this.store.dispatch(new GetVeranstaltungBerechtigungenAdminAction(item.veranstaltung_id));

            this.store.dispatch(new DokumentSelectedSetzenAction(null));
            this.istPandemieLizenzAktiv$.subscribe(x => {
                if (x) {
                    this.store.dispatch(new GetVeranstaltungPandemieInfoAction(item.veranstaltung_id));
                }
            }).unsubscribe();
        }
    }

    async veranstaltungSpeichern() {
        if (this.angelegteVeranstaltungenDetail !== null &&
            // TODO V3 das hier muss wieder rein
            // this.angelegteVeranstaltungenDetail.benutzer_kann_aktualisieren &&
            this.veranstaltungForm.get('datumBeginn').value !== null &&
            this.veranstaltungForm.get('datumBeginn').value !== '' &&
            this.veranstaltungForm.get('datumEinlass').value !== null &&
            this.veranstaltungForm.get('datumEinlass').value !== '' &&
            // this.veranstaltungForm.get('datumEinlass').value <= this.veranstaltungForm.get('datumBeginn').value &&
            this.angelegteVeranstaltungenDetail.titel !== ''
        ) {

            const veranstaltungsBeginn: Date = new Date(this.veranstaltungForm.get('datumBeginn').value);
            const veranstaltungsEinlass: Date = new Date(this.veranstaltungForm.get('datumEinlass').value);

            if (veranstaltungsEinlass <= veranstaltungsBeginn) {
                const arrayFelder: { [key: string]: string; } = {};
                if (this.angelegteVeranstaltungenDetail.kopfdaten) {
                    this.angelegteVeranstaltungenDetail.kopfdaten.forEach(x => {
                        if (x.feld_typ === 'FELD') {
                            if (x.daten_typ === 'TOGGLE' && x.wert === null) {
                                arrayFelder[x.key] = 'false';
                            } else {
                              if (x.wert !== null) {
                                arrayFelder[x.key] = x.wert.toString();
                              } else {
                                arrayFelder[x.key] = null;
                              }
                            }
                        } else if (x.feld_typ === 'GRUPPE') {
                            x.children.forEach(y => {
                                if (y.feld_typ === 'FELD') {
                                    if (y.daten_typ === 'TOGGLE' && y.wert === null) {
                                        arrayFelder[y.key] = 'false';
                                    } else {
                                      if (y.wert !== null) {
                                        arrayFelder[y.key] = y.wert.toString();
                                      } else {
                                        arrayFelder[y.key] = null;
                                      }
                                    }
                                }
                            });
                        }
                    });
                }

                const request = <apiVeranstaltungen.VeranstaltungKopfdatenAktualisierenRequest>{
                    titel: this.angelegteVeranstaltungenDetail.titel,
                    veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                    beginn_utc: veranstaltungsBeginn,
                    einlass_utc: veranstaltungsEinlass,
                    veranstaltungsleiter_rolle_id: this.angelegteVeranstaltungenDetail.veranstaltungsleiter_rolle_id,
                    beobachter_rolle_id: this.angelegteVeranstaltungenDetail.beobachter_rolle_id,
                    saison_id: (this.angelegteVeranstaltungenDetail && this.angelegteVeranstaltungenDetail.saison_id !== undefined && this.angelegteVeranstaltungenDetail.saison_id !== null) ? this.angelegteVeranstaltungenDetail.saison_id.toString() : null,
                    kopfdaten: arrayFelder,
                    zeitpunkt_utc: new Date()
                };

                this.store.dispatch(new PostVeranstaltungKopfdatenAktualisierenAction(request));
            } else {
                await this.notificationService.showAlertWarnung('Speichern nicht möglich', '', 'Der Beginn-Zeitpunkt darf zeitlich nicht vor dem Einlass-Zeitpunkt sein.');
            }
        } else {
            await this.notificationService.showAlertWarnung('Speichern nicht möglich', '', 'Bitte zuerst alle Pflichtfelder füllen und darauf achten, dass der Beginn-Zeitpunkt zeitlich nicht vor dem Einlass-Zeitpunkt steht.');
        }
    }

    async veranstaltungKopieren() {
        // TODO V3 ORGArena: Veranstaltung kopieren (Modal wird gebraucht)
        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
            const params = {
                titel: 'VERANSTALTUNG KOPIEREN',
                untertitel: 'Veranstaltung ' + this.angelegteVeranstaltungenDetail.titel + ' kopieren?',
                hinweistext: [
                    'Beim Kopieren werden folgende Daten der Veranstaltung kopiert:',
                    'Kopfdaten, beteiligte Funktionsbereiche mit Checklisten und Aufgaben, Info-Kategorien und Dokumente'
                ],
                iconName: 'copy',
                abbrechenButton: 'Abbrechen',
                okButton: 'Veranstaltung kopieren'
            };

            const modal = await this.modalCtrl.create({component: VeranstaltungKopierenPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result !== null && result.data) {
                    const veranstaltungRequest = <apiVeranstaltungen.VeranstaltungRequest>{
                        veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                        zeitpunkt_utc: new Date()
                    };
                    this.store.dispatch(new PostVeranstaltungKopierenAction(veranstaltungRequest));
                }
            });

            await modal.present();
        }
    }

    // FUNKTIONSBEREICHE
    trackByBeteiligteFunktionsbereiche(index, item) {
        return item.funktionsbereich_id;
    }

    async funktionsbereichAuswahl() {
        if (this.angelegteVeranstaltungenDetail !== null) {
            this.funktionsbereich$.subscribe(async (funktionsbereiche) => {
                    const funktionsbereichsIds = funktionsbereiche.map(x => x.vorlage_funktionsbereich_id);

                    const params = {
                        titel: this.angelegteVeranstaltungenDetail.titel,
                        aktuell: funktionsbereichsIds,
                        veranstaltungstypId: this.angelegteVeranstaltungenDetail.typ_id
                    };

                    const modal = await this.modalCtrl.create({
                        component: FunktionsbereichsauswahlPage,
                        componentProps: params
                    });
                    modal.onDidDismiss().then((result: any) => {
                        if (result !== null && result.data) {
                            const data = result.data;
                            const request = <apiVeranstaltungen.FunktionsbereichHinzufuegenMultiRequest>{
                                checklisten_anlegen: data.checklistenAnlegen,
                                funktionsbereich_vorlage_ids: [],
                                veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                                zeitpunkt_utc: new Date()
                            };

                            if (data.hinzugefuegte && data.hinzugefuegte.length > 0) {
                                data.hinzugefuegte.forEach((fbId: string) => {
                                    request.funktionsbereich_vorlage_ids.push(fbId);
                                });
                                this.store.dispatch(new PostFunktionsbereichHinzufuegenMultiAction(request));
                            }
                        }
                    });
                    return await modal.present();
                }
            ).unsubscribe();
        }
    }

    async beteiligtenFunktionsbereichEntfernen() {
        if (this.aktuellerBeteiligterFunktionsbereich) {
            const params = {titel: this.aktuellerBeteiligterFunktionsbereich.titel};
            const modal = await this.modalCtrl.create({
                component: FunktionsbereichEntfernenPage,
                componentProps: params
            });

            modal.onDidDismiss().then((result: any) => {
                if (result !== null && result.data) {
                    const data = result.data;
                    if (data !== null) {
                        const request = <apiVeranstaltungen.FunktionsbereichRequest>{
                            funktionsbereich_id: this.aktuellerBeteiligterFunktionsbereich.funktionsbereich_id,
                            veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                            zeitpunkt_utc: new Date()
                        };
                        this.store.dispatch(new PostFunktionsbereichEntfernenAction(request));
                    }
                }
            });
            return await modal.present();
        }
    }

    async beteiligtenFunktionsbereichAuswaehlen(funktionsbereich: apiVeranstaltungen.Funktionsbereich) {
        if (funktionsbereich !== null && funktionsbereich.veranstaltung_id !== null) {
            this.aktuellerBeteiligterFunktionsbereich = funktionsbereich;
        }
    }

    async funktionsbereichAuswaehlen(funktionsbereich: apiVeranstaltungen.Funktionsbereich) {
        if (funktionsbereich !== null && funktionsbereich.veranstaltung_id !== null) {
            this.aktuellerFunktionsbereich = funktionsbereich;
            this.store.dispatch(new GetFunktionsbereichChecklistenAdminAction(funktionsbereich.funktionsbereich_id));
        }
    }

// BILD / LOGO
    async bildEinfuegen() {
        // let fi = this.logoFileInput['_native'].nativeElement;
        const fi = this.logoFileInput.nativeElement;
        if (fi.files && fi.files[0]) {
            const fileToUpload = fi.files[0];

            const loading = await this.loadingCtrl.create({
                spinner: 'dots',
                message: 'Das Logo wird hochgeladen ...',
                translucent: true,
                backdropDismiss: false,
                keyboardClose: true
            });

            await loading.present();
            this.uploadCommandService.postUploadForm(fileToUpload, `veranstaltungen/${this.angelegteVeranstaltungenDetail.veranstaltung_id}/logos`).subscribe((result: UploadResponse) => {
                const request = <apiVeranstaltungen.VeranstaltungLogoAktualisierenRequest>{
                    logo_blob_id: result.upload_id,
                    veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                    zeitpunkt_utc: new Date()
                };
                loading.dismiss();
                this.store.dispatch(new PostVeranstaltungLogoAktualisierenAction(request));
            }, error2 => {
            });
        }
    }

    async bildEntfernen() {
        const request = <apiVeranstaltungen.VeranstaltungLogoAktualisierenRequest>{
            logo_blob_id: null,
            veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
            zeitpunkt_utc: new Date()
        };
        this.store.dispatch(new PostVeranstaltungLogoAktualisierenAction(request));
    }

    async bildAuswahlen() {
        this.logoFileInput.nativeElement.click();
    }

// Mögliche Statiänderungen einer Veranstaltung
    async veranstaltungVeroeffentlichen() {
        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
            const request = <apiVeranstaltungen.VeranstaltungRequest>{
                veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                zeitpunkt_utc: new Date()
            };
            this.store.dispatch(new PostVeranstaltungVeroeffentlichenAction(request));
        }
    }

    async veranstaltungLoeschen() {
        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
            const params = {
                titel: this.angelegteVeranstaltungenDetail.titel
            };

            const modal = await this.modalCtrl.create({component: VeranstaltungLoeschenPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result !== null && result.data) {
                    const data = result.data;
                    if (data !== null) {
                        const request = <apiVeranstaltungen.VeranstaltungRequest>{
                            veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                            zeitpunkt_utc: new Date()
                        };
                        this.store.dispatch(new PostVeranstaltungLoeschenAction(request));
                    }
                }
            });

            await modal.present();
        }
    }

    async veranstaltungUnveroeffentlichtSetzen() {
        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
            const params = {
                titel: 'ACHTUNG',
                subtitel: 'Die Veröffentlichung der Veranstaltung wird zurückgezogen!',
                description: 'Willst du die Veröffentlichung der Veranstaltung ' + this.angelegteVeranstaltungenDetail.titel + ' wirklich zurückziehen? Damit steht die Veranstaltung in der App nicht mehr zur Verfügung.',
                buttonOkText: 'Veröffentlichung zurückziehen'
            };

            const modal = await this.modalCtrl.create({component: HinweisMeldungPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result !== null && result.data) {
                    const data = result.data;
                    if (data !== null) {
                        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
                            const request = <apiVeranstaltungen.VeranstaltungRequest>{
                                veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                                zeitpunkt_utc: new Date()
                            };
                            this.store.dispatch(new PostVeranstaltungNichtVeroeffentlichenAction(request));
                        }
                    }
                }
            });

            await modal.present();
        }
    }

    async veranstaltungPhaseBeenden() {
        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
            const params = {
                titel: 'ACHTUNG',
                subtitel: 'Die Veranstaltung wird beendet!',
                description: 'Willst du die Veranstaltung ' + this.angelegteVeranstaltungenDetail.titel + ' wirklich beenden?',
                buttonOkText: 'Veranstaltung beenden'
            };

            const modal = await this.modalCtrl.create({component: HinweisMeldungPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result !== null && result.data) {
                    const data = result.data;
                    if (data !== null) {
                        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
                            this.veranstaltungStatus$.subscribe((status: VeranstaltungStatus) => {
                                const request = <apiVeranstaltungen.VeranstaltungPhaseRequest>{
                                    phase_id: status.phase_id,
                                    veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                                    zeitpunkt_utc: new Date()
                                };
                                this.store.dispatch(new PostVeranstaltungPhaseBeendenAction(request));
                            }).unsubscribe();
                        }
                    }
                }
            });

            await modal.present();
        }
    }

    async veranstaltungBeenden() {
        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
            const params = {
                titel: 'ACHTUNG',
                subtitel: 'Die Veranstaltung wird archiviert!',
                description: 'Willst du die Veranstaltung ' + this.angelegteVeranstaltungenDetail.titel + ' wirklich archivieren?',
                buttonOkText: 'Veranstaltung archivieren'
            };

            const modal = await this.modalCtrl.create({component: HinweisMeldungPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result !== null && result.data) {
                    const data = result.data;
                    if (data !== null) {
                        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
                            const request = <apiVeranstaltungen.VeranstaltungRequest>{
                                veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                                zeitpunkt_utc: new Date()
                            };
                            this.store.dispatch(new PostVeranstaltungBeendenAction(request));
                        }
                    }
                }
            });

            await modal.present();
        }
    }

    async veranstaltungReaktivieren() {
        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
            const params = {
                titel: 'ACHTUNG',
                subtitel: 'Die Veranstaltung wird reaktiviert!',
                description: 'Willst du die Veranstaltung ' + this.angelegteVeranstaltungenDetail.titel + ' wirklich wieder reaktivieren?',
                buttonOkText: 'Veranstaltung reaktivieren'
            };

            const modal = await this.modalCtrl.create({component: HinweisMeldungPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result !== null && result.data) {
                    const data = result.data;
                    if (data !== null) {
                        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
                            const request = <apiVeranstaltungen.VeranstaltungRequest>{
                                veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                                zeitpunkt_utc: new Date()
                            };
                            this.store.dispatch(new PostVeranstaltungReaktivierenAction(request));
                        }
                    }
                }
            });

            await modal.present();
        }

    }

    async veranstaltungFreigeben() {
        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
            const params = {
                titel: 'ACHTUNG',
                subtitel: 'Die Veranstaltung ' + this.angelegteVeranstaltungenDetail.titel + ' wird freigegeben!',
                description: 'Willst du die Veranstaltung wirklich freigeben?',
                buttonOkText: 'Veranstaltung freigeben'
            };

            const modal = await this.modalCtrl.create({component: HinweisMeldungPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result !== null && result.data) {
                    const data = result.data;
                    if (data !== null) {
                        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
                            const request = <apiVeranstaltungen.VeranstaltungRequest>{
                                veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                                zeitpunkt_utc: new Date()
                            };
                            this.store.dispatch(new PostVeranstaltungFreigebenAction(request));
                        }
                    }
                }
            });

            await modal.present();
        }
    }


// DOKUMENTE
    trackByDokument(index, item: Dokument) {
        return item.dokument_id;
    }

// Dokument aus der Liste der bereits angelegten auswählen
    async dokumentAuswaehlen(dokument: Dokument) {
        if (dokument !== null && dokument.dokument_id !== null) {

            this.store.dispatch(new DokumentSelectedSetzenAction(dokument));
            this.store.dispatch(new GetVeranstaltungDokumentBerechtigungAction(this.angelegteVeranstaltungenDetail.veranstaltung_id, dokument.dokument_id));

            setTimeout(() => {
                if (this.dokumentTitelInput) {
                    this.dokumentTitelInput.setFocus();
                }
            }, 500);
        }
    }

// Dokument-Datei per FileOpenDialog auswählen
    async dokumentDateiAuswahlen() {
        this.dokumentFileInput.nativeElement.click();
    }

    async dokumentOeffnen(dokument) {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Das Dokument wird geladen ...',
            translucent: true,
            backdropDismiss: false,
            keyboardClose: true
        });

        await loading.present();

        const url = '/api/query/veranstaltungen/' + dokument.veranstaltung_id + '/dokumente/' + dokument.dokument_id;
        this.documentService.getDocument(url).pipe(
            takeWhile(() => this.alive)
        )
            .subscribe(document => {
                    if (document !== null) {
                        loading.dismiss();
                        this.documentService.saveFile(document, dokument.dateiname);
                    }
                },
                error => {
                    alert(error);
                    loading.dismiss();
                }, () => {
                });
    }

    async dokumentEinfuegen($event: any = null) {
        // let fi = this.logoFileInput['_native'].nativeElement;
        const fi = this.dokumentFileInput.nativeElement;

        if (fi.files && fi.files[0]) {
            const fileToUpload = fi.files[0];

            const loading = await this.loadingCtrl.create({
                spinner: 'dots',
                message: 'Das Dokument wird hochgeladen ...',
                translucent: true,
                backdropDismiss: false,
                keyboardClose: true
            });

            await loading.present();

            this.uploadCommandService.postUploadForm(fileToUpload, `veranstaltungen/${this.angelegteVeranstaltungenDetail.veranstaltung_id}/dokumente`).subscribe((result: UploadResponse) => {
                this.store.dispatch(new DokumentUploadSetzenAction(result.upload_id, result.file_name));
                loading.dismiss();
            }, error2 => {
            });
        }
    }

    async neuesDokumentAnlegen() {
        const newDokument = <Dokument>{
            dokument_id: null,
            titel: '',
            beschreibung: '',
            dateiname: '',
            entity_type: '',
            veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id
        };
        this.store.dispatch(new DokumentSelectedSetzenAction(newDokument));

        setTimeout(() => {
            if (this.dokumentTitelInput) {
                this.dokumentTitelInput.setFocus();
            }
        }, 500);
    }

    async dokumentEntfernen(dokument: Dokument) {
        if (dokument !== null) {
            const request = <apiVeranstaltungen.DokumentEntfernenRequest>{
                dokument_id: dokument.dokument_id,
                veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                zeitpunkt_utc: new Date()
            };

            this.store.dispatch(new PostDokumentEntfernenAction(request));
            this.store.dispatch(new DokumentSelectedSetzenAction(null));
            // this.aktuellesDokument = null;
        }
    }

    async dokumentAbbrechen() {
        this.store.dispatch(new DokumentSelectedSetzenAction(null));
    }

    async dokumentSpeichern(dokument: Dokument) {
        if (dokument !== null && (dokument.dokument_id === null || dokument.dokument_id === undefined)) {
            const uuid = this.uuid.generateUUID();
            const request = <apiVeranstaltungen.DokumentHinzufuegenRequest>{
                dokument_upload_id: dokument.dokument_upload_id,
                dokument_id: uuid,
                veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                zeitpunkt_utc: new Date(),
                titel: dokument.titel,
                beschreibung: dokument.beschreibung,
                gruppierung: dokument.gruppierung,
                dateiname: dokument.dateiname,
                ist_oeffentlich: dokument.ist_oeffentlich
            };

            this.store.dispatch(new DokumentIdSetzenAction(uuid));
            this.store.dispatch(new PostDokumentHinzufuegenAction(request));
            // this.store.dispatch(new GetVeranstaltungDokumentBerechtigungAction(this.angelegteVeranstaltungenDetail.veranstaltung_id, uuid));
        } else {
            let time = 0;

            let titel = '';
            let beschreibung = '';

            if (dokument) {
                titel = dokument.titel;
                beschreibung = dokument.beschreibung;

                const request = <apiVeranstaltungen.DokumentUploadAktualisierenRequest>{
                    dokument_id: dokument.dokument_id,
                    veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                    dateiname: dokument.dateiname,
                    dokument_upload_id: dokument.dokument_upload_id,
                    zeitpunkt_utc: new Date()
                };

                this.store.dispatch(new PostDokumentUploadAktualisierenAction(request));
                time = 500;
            }

            setTimeout(() => {
                const request = <apiVeranstaltungen.DokumentAktualisierenRequest>{
                    dokument_id: dokument.dokument_id,
                    veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                    zeitpunkt_utc: new Date(),
                    ist_oeffentlich: dokument.ist_oeffentlich,
                    gruppierung: dokument.gruppierung,
                    titel,
                    beschreibung
                };

                this.store.dispatch(new PostDokumentAktualisierenAction(request));
            }, time);

        }
    }

    async leseBerechtigungRollenAuswahl(dokument) {
        if (dokument !== null) {
            const params = {
                veranstaltungsId: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                titel: '| Dokument Lese Berechtigung',
                nichtAnzuzeigendeRollenIds: dokument.berechtigung_rollen_ids,
                checkliste: null,
                untertitel: dokument.beschreibung,
                alleAnzeigenAuswahlAnzeigen: false,
                alleAnzeigen: true,
                datenquelle: Datenquelle.Veranstaltung
            };

            const modal = await this.modalCtrl.create({
                component: RollenselektionPage,
                componentProps: params
            });
            modal.onDidDismiss().then((result: any) => {
                if (result !== null && result.data) {
                    const data = result.data;
                    const rolleIds = [];
                    data.ausgewaehlteRollen.forEach((rolleId) => {
                        rolleIds.push(rolleId);
                    });

                    const request = <apiVeranstaltungen.DokumentBerechtigungMultiRequest>{
                        dokument_id: dokument.dokument_id,
                        veranstaltung_id: dokument.veranstaltung_id,
                        zeitpunkt_utc: new Date(),
                        rolle_ids: rolleIds
                    };

                    this.store.dispatch(new PostDokumentBerechtigungHinzufuegenMultiAction(request));
                }
            });

            await modal.present();
        }
    }

    async bearbeitenBerechtigungRollenAuswahl(dokument) {
        if (dokument !== null) {
            const params = {
                veranstaltungsId: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                titel: '| Dokument Bearbeiten-Berechtigung',
                nichtAnzuzeigendeRollenIds: dokument.bearbeiten_berechtigung_rollen_ids,
                checkliste: null,
                untertitel: dokument.beschreibung,
                alleAnzeigenAuswahlAnzeigen: false,
                alleAnzeigen: true,
                datenquelle: Datenquelle.Veranstaltung
            };

            const modal = await this.modalCtrl.create({
                component: RollenselektionPage,
                componentProps: params
            });
            modal.onDidDismiss().then((result: any) => {
                if (result !== null && result.data) {
                    const data = result.data;
                    const rolleIds = [];
                    data.ausgewaehlteRollen.forEach((rolleId) => {
                        rolleIds.push(rolleId);
                    });

                    const request = <apiVeranstaltungen.DokumentBerechtigungMultiRequest>{
                        dokument_id: dokument.dokument_id,
                        veranstaltung_id: dokument.veranstaltung_id,
                        zeitpunkt_utc: new Date(),
                        rolle_ids: rolleIds
                    };

                    this.store.dispatch(new PostDokumentBearbeitenBerechtigungHinzufuegenMultiAction(request));
                }
            });

            await modal.present();
        }
    }

    async dokumentLeseBerechtigungRolleEntfernen() {
        this.store.dispatch(new DokumentLeseBerechtigungenEntfernenAction());
    }

    async dokumentBearbeitenBerechtigungRolleEntfernen() {
        this.store.dispatch(new DokumentBearbeitenBerechtigungenEntfernenAction());
    }

// CHECKLISTEN
    async funktionsbereichChecklisteAuswaehlen(checkliste: apiVeranstaltungen.Checkliste) {
        this.funktionsbereich$.subscribe(fbe => {
            fbe.find(fb => {
                if (fb.funktionsbereich_id === checkliste.funktionsbereich_id) {
                    this.aufgabeFunktionsbereich = fb;
                }
            });
        }).unsubscribe();
        this.store.dispatch(new FunktionsbereichChecklisteSetzenAction(checkliste));
        this.store.dispatch(new GetChecklisteAufgabenAdminAction(checkliste.checkliste_id));
    }

    async aufgabeAuswaehlen(aufgabe: apiVeranstaltungen.Aufgabe) {
        this.store.dispatch(new AufgabeSetzenAction(aufgabe));
    }

    async funktionsbereichChecklisteEntfernen() {
        this.uiSelektiertFunktionsbereicheCheckliste$.subscribe(async (checkliste) => {
                if (checkliste !== null) {
                    const componentProps = {titel: checkliste.titel};
                    const modal = await this.modalCtrl.create({component: ChecklisteEntfernenPage, componentProps});
                    modal.onDidDismiss().then((result: any) => {
                        if (result !== null && result.data) {
                            const request = <apiVeranstaltungen.ChecklisteRequest>{
                                checkliste_id: checkliste.checkliste_id,
                                veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                                funktionsbereich_id: checkliste.funktionsbereich_id,
                                zeitpunkt_utc: new Date()
                            };

                            this.store.dispatch(new PostChecklisteEntfernenAction(request));
                        }
                    });

                    await modal.present();
                }
            }
        ).unsubscribe();
    }

    // TODO: TZ
    // Zur Bearbeitung des Aufgaben-Textes
    async aufgabeBearbeiten(checkliste: Checkliste) {
        this.selectedAufgabe$.subscribe(async (aktuelleAufgabe: AufgabeAdmin) => {

            // console.log('AktuelleAufgabe: ', aktuelleAufgabe);
            const aktuelleAufgabeModel = <apiVorlagen.Aufgabe>{
                titel: aktuelleAufgabe.titel,
                beschreibung: aktuelleAufgabe.beschreibung,
                ist_optional: aktuelleAufgabe.ist_optional,
                referenz_zeitpunkt: aktuelleAufgabe.referenz_zeitpunkt,
                ist_erinnerung_aktiv: aktuelleAufgabe.ist_erinnerung_aktiv,
                erinnerung_relativ_minuten: aktuelleAufgabe.erinnerung_relativ_minuten,
                erinnerung_relativ_tage: aktuelleAufgabe.erinnerung_relativ_tage,
                ist_eskalation_aktiv: aktuelleAufgabe.ist_eskalation_aktiv,
                ist_veranstaltungsrelevant: aktuelleAufgabe.phase_id === 'VERANSTALTUNG',
                eskalation_relativ_minuten: aktuelleAufgabe.eskalation_relativ_minuten,
                eskalation_relativ_tage: aktuelleAufgabe.eskalation_relativ_tage,
                ist_eskalation_an_freigeber_funktionsbereich_aktiv: aktuelleAufgabe.ist_eskalation_an_freigeber_funktionsbereich_aktiv,
                ist_eskalation_an_freigeber_checkliste_aktiv: aktuelleAufgabe.ist_eskalation_an_freigeber_checkliste_aktiv,
                ist_eskalation_an_abarbeiter_aktiv: aktuelleAufgabe.ist_eskalation_an_abarbeiter_aktiv,
                ist_erinnerung_uhrzeit_fix: aktuelleAufgabe.ist_erinnerung_uhrzeit_fix,
                ist_eskalation_uhrzeit_fix: aktuelleAufgabe.ist_eskalation_uhrzeit_fix,
                erinnerung_uhrzeit_fix_stunden: aktuelleAufgabe.erinnerung_uhrzeit_fix_stunden,
                erinnerung_uhrzeit_fix_minuten: aktuelleAufgabe.erinnerung_uhrzeit_fix_minuten,
                eskalation_uhrzeit_fix_stunden: aktuelleAufgabe.eskalation_uhrzeit_fix_stunden,
                eskalation_uhrzeit_fix_minuten: aktuelleAufgabe.eskalation_uhrzeit_fix_minuten,
                reihenfolge: aktuelleAufgabe.reihenfolge,

                erinnerung_fix_wochentag: aktuelleAufgabe.erinnerung_fix_wochentag,
                eskalation_fix_wochentag: aktuelleAufgabe.eskalation_fix_wochentag,
                relation: aktuelleAufgabe.relation,
                ist_erinnerung_wochentag_fix: Boolean(aktuelleAufgabe.ist_erinnerung_wochentag_fix),
                ist_eskalation_wochentag_fix: Boolean(aktuelleAufgabe.ist_eskalation_wochentag_fix),
            };

            const params = {
                aufgabe: aktuelleAufgabeModel,
                titel: aktuelleAufgabe.titel,
                funktionsbereich: this.aufgabeFunktionsbereich,
                checkliste: checkliste,
                untertitel: 'Aufgabe bearbeiten',
                veranstaltungsId: checkliste.veranstaltung_id
            };

            const modal = await this.modalCtrl.create({component: AufgabePage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result.data !== undefined && result.data !== null && result.data.aufgabe !== null) {
                    const aufgabeAktualisierenRequest = <apiVeranstaltungen.AufgabeAnlegenRequest>{
                        titel: result.data.aufgabe.titel,
                        beschreibung: result.data.aufgabe.beschreibung,
                        ist_optional: result.data.aufgabe.ist_optional,
                        referenz_zeitpunkt: result.data.aufgabe.referenz_zeitpunkt,
                        ist_erinnerung_aktiv: result.data.aufgabe.ist_erinnerung_aktiv,
                        erinnerung_relativ_minuten: result.data.aufgabe.erinnerung_relativ_minuten,
                        erinnerung_relativ_tage: result.data.aufgabe.erinnerung_relativ_tage,
                        ist_eskalation_aktiv: result.data.aufgabe.ist_eskalation_aktiv,
                        ist_veranstaltungsrelevant: result.data.aufgabe.ist_veranstaltungsrelevant,
                        eskalation_relativ_minuten: result.data.aufgabe.eskalation_relativ_minuten,
                        eskalation_relativ_tage: result.data.aufgabe.eskalation_relativ_tage,
                        ist_eskalation_an_freigeber_funktionsbereich_aktiv: result.data.aufgabe.ist_eskalation_an_freigeber_funktionsbereich_aktiv,
                        ist_eskalation_an_freigeber_checkliste_aktiv: result.data.aufgabe.ist_eskalation_an_freigeber_checkliste_aktiv,
                        ist_eskalation_an_abarbeiter_aktiv: result.data.aufgabe.ist_eskalation_an_abarbeiter_aktiv,
                        ist_eskalation_an_veranstaltungsleiter_aktiv: result.data.aufgabe.ist_eskalation_an_veranstaltungsleiter_aktiv,

                        ist_erinnerung_uhrzeit_fix: result.data.aufgabe.ist_erinnerung_uhrzeit_fix,
                        ist_eskalation_uhrzeit_fix: result.data.aufgabe.ist_eskalation_uhrzeit_fix,
                        erinnerung_uhrzeit_fix_stunden: result.data.aufgabe.erinnerung_uhrzeit_fix_stunden,
                        erinnerung_uhrzeit_fix_minuten: result.data.aufgabe.erinnerung_uhrzeit_fix_minuten,
                        eskalation_uhrzeit_fix_stunden: result.data.aufgabe.eskalation_uhrzeit_fix_stunden,
                        eskalation_uhrzeit_fix_minuten: result.data.aufgabe.eskalation_uhrzeit_fix_minuten,
                        reihenfolge: result.data.aufgabe.reihenfolge,

                        erinnerung_fix_wochentag: result.data.aufgabe.erinnerung_fix_wochentag,
                        eskalation_fix_wochentag: result.data.aufgabe.eskalation_fix_wochentag,
                        relation: result.data.aufgabe.relation,
                        ist_erinnerung_wochentag_fix: Boolean(result.data.aufgabe.ist_erinnerung_wochentag_fix),
                        ist_eskalation_wochentag_fix: Boolean(result.data.aufgabe.ist_eskalation_wochentag_fix),

                        veranstaltung_id: aktuelleAufgabe.veranstaltung_id,
                        aufgabe_id: aktuelleAufgabe.aufgabe_id,
                        checkliste_id: aktuelleAufgabe.checkliste_id,
                        funktionsbereich_id: aktuelleAufgabe.funktionsbereich_id,
                        zeitpunkt_utc: new Date()
                    };
                    this.store.dispatch(new PostAufgabeAktualisierenAction(aufgabeAktualisierenRequest));
                }
            });

            await modal.present();
        }).unsubscribe();
    }

    async checklistenAuswahl() {
        if (this.angelegteVeranstaltungenDetail !== null) {
            this.funktionsbereicheChecklisten$.subscribe(async (listInputItem: Array<ListInputItem>) => {
                    const beteiligteFunktionsbereichIds = [];
                    this.funktionsbereich$.subscribe(async fbResults => {
                        fbResults.forEach(async (fb) => {
                            beteiligteFunktionsbereichIds.push(fb.vorlage_funktionsbereich_id);
                        });

                        if (listInputItem) {
                            let hinzugefuegteChecklistenIds = [];
                            listInputItem.forEach((fbCl) => {
                                const checklistenIds = fbCl.item.vorlage_checkliste_id;
                                hinzugefuegteChecklistenIds = hinzugefuegteChecklistenIds.concat(checklistenIds);
                            });

                            const params = {
                                titel: this.angelegteVeranstaltungenDetail.titel,
                                aktuell: hinzugefuegteChecklistenIds,
                                beteiligteFunktionsbereiche: beteiligteFunktionsbereichIds
                            };

                            const modal = await this.modalCtrl.create({
                                component: ChecklistenauswahlPage,
                                componentProps: params
                            });

                            modal.onDidDismiss().then((result: any) => {
                                if (result !== null && result.data) {
                                    const data = result.data;
                                    const request = <apiVeranstaltungen.ChecklisteHinzufuegenMultiRequest>{
                                        checkliste_vorlage_ids: [],
                                        veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                                        zeitpunkt_utc: new Date()
                                    };

                                    data.hinzugefuegte.forEach((cl: apiVeranstaltungen.Checkliste) => {
                                        request.checkliste_vorlage_ids.push(cl.checkliste_id);
                                    });

                                    this.store.dispatch(new PostChecklisteHinzufuegenMultiAction(request));
                                }
                            });

                            await modal.present();
                        }
                    }).unsubscribe();
                }
            ).unsubscribe();
        }
    }

    // AUFGABEN
    async aufgabeAktivierenDeaktivieren(aufgabe) {
        this.uiSelektiertFunktionsbereicheCheckliste$.subscribe((fbCl) => {
                if (fbCl !== null) {

                    // Aufgabe hinzufügen
                    const request = <apiVeranstaltungen.AufgabeRequest>{
                        aufgabe_id: aufgabe.aufgabe_id,
                        checkliste_id: fbCl.checkliste_id,
                        funktionsbereich_id: fbCl.funktionsbereich_id,
                        veranstaltung_id: fbCl.veranstaltung_id,
                        zeitpunkt_utc: new Date()
                    };

                    if (!aufgabe.ist_aktiv) {
                        this.store.dispatch(new PostAufgabeAktivierenAction(request));
                    } else {
                        this.store.dispatch(new PostAufgabeDeaktivierenAction(request));
                    }
                }
            }
        ).unsubscribe();

    }


// FUNKTIONSBEREICHROLLEN

    async refreshFunktionsbereicheRollen() {
        this.store.dispatch(new GetVeranstaltungFunktionsbereicheRollenAdminAction(this.aktuelleVeranstaltungId));
    }

    async rollenBenutzerLaden(item: { funktionsbereich: apiVeranstaltungen.Funktionsbereich, rolle: apiVeranstaltungen.Rolle, berechtigung: FunktionsbereichBerechtigung }) {
        if (item && item.funktionsbereich !== null && item.rolle !== null && item.rolle.vorlage_rolle_id !== null && item.rolle.rolle_id !== null) {
            this.rollenBenutzerAktuellerFunktionsbereich = item.funktionsbereich;
            this.rollenBenutzerAktuelleFBBerechtigungen = item.berechtigung;
            this.rollenBenutzerAktuelleRolle = item.rolle;
            this.store.dispatch(new GetVeranstaltungsTypRolleBenutzerAction(this.angelegteVeranstaltungenDetail.typ_id, item.rolle.vorlage_rolle_id));
            this.store.dispatch(new GetRolleBenutzerAdminAction(item.rolle.rolle_id));
            this.store.dispatch(new RolleSetzenAction(item.rolle));
        }
    }

// ROLLEN BENUTZER
    async benutzerVomDienstBefreien(benutzer: apiVeranstaltungen.RolleBenutzer) {
        if (this.rollenBenutzerAktuellerFunktionsbereich !== null && this.rollenBenutzerAktuellerFunktionsbereich.funktionsbereich_id !== null && this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
            const request = <apiVeranstaltungen.BenutzerVomDienstBefreienRequest>{
                funktionsbereich_id: this.rollenBenutzerAktuellerFunktionsbereich.funktionsbereich_id,
                veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                rolle_id: benutzer.rolle_id,
                benutzer_id: benutzer.benutzer_id,
                zeitpunkt_utc: new Date()

            };
            this.store.dispatch(new PostBenutzerVomDienstBefreienAction(request));
        }
    }


// VERHEIRATEN & ENTFERNEN
    async benutzerZumDienstEinteilen() {
        if (this.rollenBenutzerAktuellerFunktionsbereich !== null
            && this.rollenBenutzerAktuellerFunktionsbereich.funktionsbereich_id !== null
            && this.angelegteVeranstaltungenDetail !== null
            && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null
            && this.rollenBenutzerAktuelleRolle !== null
            && this.rollenBenutzerAktuelleRolle.rolle_id !== null
        ) {
            // Benutzerliste laden
            this.uiRollenBenutzerSelektiert$.subscribe(benutzerIds => {
                if (benutzerIds.length > 0) {
                    const request = <apiVeranstaltungen.BenutzerZumDienstEinteilenMultiRequest>{
                        funktionsbereich_id: this.rollenBenutzerAktuellerFunktionsbereich.funktionsbereich_id,
                        veranstaltung_id: this.angelegteVeranstaltungenDetail.veranstaltung_id,
                        rolle_id: this.rollenBenutzerAktuelleRolle.rolle_id,
                        zeitpunkt_utc: new Date(),
                        benutzer_ids: benutzerIds
                    };

                    this.store.dispatch(new PostBenutzerZumDienstEinteilenMultiAction(request));
                }
            }).unsubscribe();
        }
    }

    async rollenBenutzerIdsAuswahl(ids: Array<string>) {
        this.store.dispatch(new RollenBenutzerSetzenAction(ids));
    }

    async refreshRollenBenutzerLaden() {
        if (this.rollenBenutzerAktuellerFunktionsbereich && this.rollenBenutzerAktuelleRolle && this.rollenBenutzerAktuelleFBBerechtigungen) {
            this.rollenBenutzerLaden({
                funktionsbereich: this.rollenBenutzerAktuellerFunktionsbereich,
                rolle: this.rollenBenutzerAktuelleRolle,
                berechtigung: this.rollenBenutzerAktuelleFBBerechtigungen
            });
        }
    }






    // ALLGEMEINE FUNKTIONEN
    async pruefdokumentOeffnen() {
        if (this.angelegteVeranstaltungenDetail !== null && this.angelegteVeranstaltungenDetail.veranstaltung_id !== null) {
            const loading = await this.loadingCtrl.create({
                spinner: 'dots',
                message: 'Das Dokument wird geladen ...',
                translucent: true,
                backdropDismiss: false,
                keyboardClose: true
            });

            await loading.present();

            const url = '/api/query/veranstaltungen/' + this.angelegteVeranstaltungenDetail.veranstaltung_id + '/pruefbericht';
            this.documentService.getDocument(url).pipe(takeWhile(() => this.alive))
                .subscribe(document => {
                        if (document !== null) {
                            loading.dismiss();
                            this.documentService.saveFile(document, this.replaceSpecialCharacter(this.angelegteVeranstaltungenDetail.titel));
                        } else {
                            // no content
                            loading.dismiss();
                        }
                    },
                    error => {
                        alert(error);
                        loading.dismiss();
                    }, () => {
                    });
        }
    }


    replaceSpecialCharacter(value: string) {
        return value
            .replace(/\./g, '')
            .replace(/:/g, '_')
            .replace(/ /g, '_')
            .replace(/ä/g, 'ae')
            .replace(/Ä/g, 'Ae')
            .replace(/ü/g, 'ue')
            .replace(/Ü/g, 'Ue')
            .replace(/ö/g, 'oe')
            .replace(/Ö/g, 'Oe')
            .replace(/ß/g, 'ss')
            .replace(/\//g, '-')
            .replace(/\\/g, '-')
            ;
    }

    changeFeld($event: CustomEvent, feld: KopfdatenElement) {
        this.store.dispatch(new SetzeVeranstaltungFeldAction(feld.key, $event.detail.value));
    }

    nextTab($event: CustomEvent | FocusEvent) {
        setTimeout(function () {
            const nextEl = this.findNextTabStop(document.activeElement);
            if (nextEl && nextEl.setFocus) {
                nextEl.setFocus();
            }
        }.bind(this), 300);
    }

    findNextTabStop(el) {
        const universe = document.querySelectorAll(
            'input, button, select, textarea, a[href]'
        );
        const list = Array.prototype.filter.call(universe, function (item) {
            return item.tabIndex >= '0';
        });
        const index = list.indexOf(el);
        return list[index + 1] || list[0];
    }

    trackByKopfdaten(index: number, feld: KopfdatenElement) {
        return index + feld.key;
    }

    getSumme(children: Array<KopfdatenElement>) {
        let ret = 0;
        children.forEach(x => {
            if (x.daten_typ === 'INT' && x.wert !== undefined && x.wert !== null && x.wert !== '' && (Number(x.wert).toString() !== 'NaN')) {
                ret = ret + Number(x.wert);
            }
        });
        return ret;
    }

    async changeTitel($event) {
        await this.store.dispatch(new SetzeVeranstaltungTitelAction($event.target.value));
    }

    async changeSaison($event: CustomEvent) {
        await this.store.dispatch(new SetzeVeranstaltungSaisonAction($event.detail.value));
    }


    async changeSelect($event: CustomEvent, feld: KopfdatenElement) {
        await this.store.dispatch(new SetzeVeranstaltungFeldAction(feld.key, $event.detail.value));
    }

    async changeToggle($event: CustomEvent, feld: KopfdatenElement) {
        await this.store.dispatch(new SetzeVeranstaltungFeldAction(feld.key, $event.detail.checked));
    }

    async toggleSectionAktionPreview() {
        this.sectionAktionPreviewIstOffen = !this.sectionAktionPreviewIstOffen;
        // console.log('----- sectionAktionPreviewIstOffen: ' + this.sectionAktionPreviewIstOffen);
    }

    insertTextAtPosition($event, bereich = 'info', insertText = '[Text](https://website.de)') {
        const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
        const value = textArea.value;
        const start = textArea.selectionStart;
        const end = textArea.selectionEnd;

        textArea.value = value.slice(0, start) + insertText + value.slice(end);

       if (bereich === 'aktion') {
            this.aktuelleAktion.info_text = textArea.value;
        }

        // textArea.selectionStart = textArea.selectionEnd = start + insertText.length;
        textArea.selectionStart = textArea.selectionEnd = start + 1;

        textArea.focus();
    }

    insertTextAtPositionNewTab($event, bereich = 'info', insertText = '<a href="https://webseite.de/" target="_blank">Text</a>') {
        const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
        const value = textArea.value;
        const start = textArea.selectionStart;
        const end = textArea.selectionEnd;

        textArea.value = value.slice(0, start) + insertText + value.slice(end);

       if (bereich === 'aktion') {
            this.aktuelleAktion.info_text = textArea.value;
        }

        // textArea.selectionStart = textArea.selectionEnd = start + insertText.length;
        textArea.selectionStart = textArea.selectionEnd = start + 1;

        textArea.focus();
    }

    changeStichtag($event: Md2DateChange) {
        this.store.dispatch(new SetzeVeranstaltungStichtagPandemieLevelAction($event.value));
    }

    pandemieLevelAbfragen() {
        this.store.dispatch(new PandemieLevelAbfrageAction());
    }

    levelAuswaehlen(level: PandemieLevel) {
        this.store.dispatch(new SetzePandemieLevelUiAction(level));
    }

    async pandemieLevelEinstellen() {
        const alert = await this.alertCtrl.create({
            header: 'Achtung! Einstellen des Pandemie-Levels',
            message: 'Soll der Pandemie-Level wirklich jetzt gesetzt werden?',
            buttons: [
                {
                    text: 'Ja',
                    handler: data => {
                        this.store.dispatch(new PandemieLevelEinstellenAction());
                    }
                },
                {
                    text: 'Nein',
                    handler: data => {

                    }
                }
            ]
        });
        await alert.present();
    }

    dokumentAendernInput($event, dokument: Dokument, propName: string = null, propTyp: string = null) {
        if (propName !== null) {
            if (propTyp === 'date') {
                // DATE
                dokument = Object.assign({}, dokument, {[propName]: this[propName]});
            } else {
                // SELECT
                dokument = Object.assign({}, dokument, {[propName]: $event});
            }
        } else if ($event.currentTarget.localName === 'ion-toggle') {
            // TOGGLE
            dokument = Object.assign({}, dokument, {[$event.currentTarget.id]: $event.detail.checked});
        } else if ($event.target.localName === 'ion-checkbox') {
            // CHECKBOX
            dokument = Object.assign({}, dokument, {[$event.target.id]: $event.detail.checked});
        } else if ($event.target.name !== null && $event.target.name !== '') {
            // INPUT
            dokument = Object.assign({}, dokument, {[$event.target.name]: $event.target.value});
        }

        this.store.dispatch(new AktuellesDokumentAendernAction(dokument));
    }

    leseRollenSelectionChanged($event: Array<string>) {
        this.store.dispatch(new DokumentLeseBerechtigungenSelectedSetzenAction($event));
    }

    bearbeitenRollenSelectionChanged($event) {
        this.store.dispatch(new DokumentBearbeitenBerechtigungenSelectedSetzenAction($event));
    }

    async autoresize($event = null) {
        const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];

        if (this.element.nativeElement.getElementsByTagName('textarea')[0].scrollHeight <= 200) {
            textArea.style.overflow = 'hidden';
            textArea.style.height = 'auto';
            textArea.style.height = this.element.nativeElement.getElementsByTagName('textarea')[0].scrollHeight + 'px';
        } else {
            textArea.style.overflow = 'auto';
            textArea.style.height = 'auto';
            textArea.style.height = '200px';
        }
    }

    async changeVeranstaltungsleiter() {
        const params = {
            veranstaltungsId: this.angelegteVeranstaltungenDetail.veranstaltung_id,
            titel: '| ' + this.angelegteVeranstaltungenDetail.veranstaltungs_typ.veranstaltungsleiter_text,
            nichtAnzuzeigendeRollenIds: [],
            checkliste: null,
            untertitel: '',
            alleAnzeigenAuswahlAnzeigen: false,
            alleAnzeigen: true,
            datenquelle: Datenquelle.Veranstaltung,
            einzelauswahl: true
        };

        const modal = await this.modalCtrl.create({
            component: RollenselektionPage,
            componentProps: params
        });
        modal.onDidDismiss().then((result: any) => {
            if (result !== null && result.data) {
                const data = result.data;
                let rolleId = '';
                if (data.ausgewaehlteRollen.length > 0) {
                    rolleId = data.ausgewaehlteRollen[0];
                }

                this.store.dispatch(new SetzeVeranstaltungVeranstaltungsleiterAction(rolleId));
            }
        });

        await modal.present();
    }

    async changeBeobachter() {
        const params = {
            veranstaltungsId: this.angelegteVeranstaltungenDetail.veranstaltung_id,
            titel: '| ' + this.angelegteVeranstaltungenDetail.veranstaltungs_typ.beobachter_text,
            nichtAnzuzeigendeRollenIds: [],
            checkliste: null,
            untertitel: '',
            alleAnzeigenAuswahlAnzeigen: false,
            alleAnzeigen: true,
            datenquelle: Datenquelle.Veranstaltung,
            einzelauswahl: true
        };

        const modal = await this.modalCtrl.create({
            component: RollenselektionPage,
            componentProps: params
        });
        modal.onDidDismiss().then((result: any) => {
            if (result !== null && result.data) {
                const data = result.data;
                let rolleId = '';
                if (data.ausgewaehlteRollen.length > 0) {
                    rolleId = data.ausgewaehlteRollen[0];
                }

                this.store.dispatch(new SetzeVeranstaltungVeranstaltungsbeobachterAction(rolleId));
            }
        });

        await modal.present();
    }

    async changeVeranstaltungstyp() {
        const params = {
            titel: 'Neue Veranstaltung',
            nichtAnzuzeigendeTypenIds: [],
            untertitel: 'Veranstaltungstyp auswählen',
            datenquelle: DatenquelleVeranstaltungsTypen.Veranstaltungen,
            enableSingleSelection: true
        };
        // console.log('Params: ', params);
        const modal = await this.modalCtrl.create({component: VeranstaltungstypAuswahlPage, componentProps: params});
        modal.onDidDismiss().then((result: any) => {
            if (result != null && result.data) {
                if (result.data.ausgewaehlterTyp !== null) {
                    this.angelegteVeranstaltungenDetail.typ_id = result.data.ausgewaehlterTyp.veranstaltungstyp_id;
                    this.angelegteVeranstaltungenDetail.typ_bezeichnung = result.data.ausgewaehlterTyp.bezeichnung;
                }
            }
        });

        await modal.present();
    }

    // AufgabenBerechtigungen
    async ladeFunktionsbereiche() {
        this.store.dispatch(new GetVeranstaltungFunktionsbereicheAdminAction(this.aktuelleVeranstaltungId));
    }

    funktionsbereichLaden(fb: Funktionsbereich) {
        this.store.dispatch(new FunktionsbereichSetzenAction(fb.funktionsbereich_id));
    }

    async ladeAufgabenBerechtigungDaten(fbId) {
        this.store.dispatch(new FunktionsbereichSetzenAction(fbId));
    }

    trackByItem(index, item: Benutzer) {
        return item.benutzer_id;
    }

    aufgabenAuswaehlen(values: Array<string>) {
        this.store.dispatch(new SetSelectedAufgabenAction(values));
    }

    async waehleBenutzer() {
        const params = {
            veranstaltungsId: this.aktuelleVeranstaltungId
        };
        const modal = await this.modalCtrl.create({component: AufgabenBerechtigungenModalPage, componentProps: params});
        modal.onDidDismiss().then((data: any) => {
            if (data.data !== undefined && data.data.hinzugefuegte !== undefined && data.data.hinzugefuegte.length > 0) {
                this.store.dispatch(new BenutzerberechtigungenHinzufuegenAction(data.data.hinzugefuegte));
            }
        });

        await modal.present();
    }

    async selectUser(ev, user: any) {
        const popover = await this.popoverController.create({
            component: PopoverComponentPage,
            cssClass: 'my-custom-class',
            event: ev,
            translucent: true,
            componentProps: {
                user
            }
        });
        await popover.present();
        popover.onDidDismiss().then((result) => {
            if (result.data !== undefined && result.data !== null && result.data === true) {
                this.store.dispatch(new BenutzerberechtigungenEntfernenAction(user));
            }
        });

    }


    async downloadAufgabenBerechtigungenExcel() {
      const loading = await this.loadingCtrl.create({
          spinner: 'dots',
          message: 'Exceldownload für Funktionsbereiche wird geladen'
      });
      await loading.present();

      const url = '/api/query/veranstaltungen/admin/' + this.veranstaltungsId + '/aufgaben-berechtigungen-benutzer/excel';
      this.documentService.getDocument(url, {}).pipe(takeWhile(() => this.alive)).pipe(takeUntil(this.unsubscribe$))
          .subscribe(async (document) => {
                  if (document != null) {
                      // console.log('loaded');
                      await loading.dismiss();

                      const date = new Date();
                      const month: number = <number>date.getMonth() + 1;
                      this.documentService.saveFile(document, 'Veranstaltung-Funktionsbereiche-Aufgaben-Berechtigungen-' + date.getFullYear() + '-' + month + '-' + date.getDate());
                  }
              },
              error => {
                  this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                  loading.dismiss();
              }, () => {
              });
  }

  async downloadAufgabenBerechtigungenFbExcel(fbId: string) {
    const loading = await this.loadingCtrl.create({
        spinner: 'dots',
        message: 'Exceldownload für Funktionsbereich wird geladen'
    });
    await loading.present();

    const url = '/api/query/veranstaltungen/admin/' + this.veranstaltungsId + '/funktionsbereiche/' + fbId + '/aufgaben-berechtigungen-benutzer/excel';
    this.documentService.getDocument(url, {}).pipe(takeWhile(() => this.alive)).pipe(takeUntil(this.unsubscribe$))
        .subscribe(async (document) => {
                if (document != null) {
                    // console.log('loaded');
                    await loading.dismiss();

                    const date = new Date();
                    const month: number = <number>date.getMonth() + 1;
                    this.documentService.saveFile(document, 'Veranstaltung-Funktionsbereich-Aufgaben-Berechtigungen-' + date.getFullYear() + '-' + month + '-' + date.getDate());
                }
            },
            error => {
                this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                loading.dismiss();
            }, () => {
            });
  }
}
